export const apiData = [
  {
    id: 1,
    job_title: "Junior HR Manager",
    category: "Development",
    status: "Open",
    salary: "$40K - $50K",
    location: "Bangalore",
    posted_by: "Mohan",
    createdAt: "12/02/2023",
  },
  {
    id: 2,
    job_title: "Head of Design",
    category: "Sales",
    status: "Hold",
    salary: "$80K - $90K",
    location: "New Delhi",
    posted_by: "Rohit",
    createdAt: "12/02/2023",
  },
  {
    id: 3,
    job_title: "Associate Product Designer",
    category: "Administrative",
    status: "Closed",
    salary: "$80K - $150K",
    location: "Bangalore",
    posted_by: "Mohan",
    createdAt: "12/02/2023",
  },
];
